import React, {useEffect, useState} from 'react';
import {Fade} from '@mui/material';
import './AIThinkingLoader.scss';

interface AIThinkingLoaderProps {
  open: boolean;
}

const AI_THINKING_LOADER_CONSTANT = {
  stepOne: 1,
  stepOneTimer: 200,
  stepTwo: 2,
  stepTwoTimer: 600,
  stepThree: 3,
  stepThreeTimer: 1500,
  fadeTimeout: 200,
};
const AIThinkingLoader: React.FC<AIThinkingLoaderProps> = ({open}) => {
  const {
    stepOne,
    stepOneTimer,
    stepTwo,
    stepTwoTimer,
    stepThree,
    stepThreeTimer,
    fadeTimeout,
  } = AI_THINKING_LOADER_CONSTANT;
  const [step, setStep] = useState(stepOne);

  useEffect(() => {
    if (!open) {
      setStep(stepOne);
      return;
    }

    const timers = [
      setTimeout(() => setStep(stepOne), stepOneTimer),
      setTimeout(() => setStep(stepTwo), stepTwoTimer),
      setTimeout(() => setStep(stepThree), stepThreeTimer),
    ];

    return () => timers.forEach(clearTimeout);
  }, [open]);

  return (
    <Fade in={open} timeout={fadeTimeout}>
      <div
        className={`ai-thinking-loader step-${step}`}
        data-testid="ai-thinking-loader"
        aria-label="AI is thinking"
        role="status"
      >
        <div
          className="bar bar-1"
          data-testid="ai-thinking-loader-bar-1"
          aria-hidden="true"
        />
        <div
          className="bar bar-2"
          data-testid="ai-thinking-loader-bar-2"
          aria-hidden="true"
        />
        <div
          className="bar bar-3"
          data-testid="ai-thinking-loader-bar-3"
          aria-hidden="true"
        />
        <div
          className="bar bar-4"
          data-testid="ai-thinking-loader-bar-4"
          aria-hidden="true"
        />
      </div>
    </Fade>
  );
};
export default AIThinkingLoader;
